export default {
  EVENTS: {
    BOOKING: {
      // Fetch
      FETCH_MY_BOOKINGS: 'booking.fetch_my_bookings',
      FETCH_MY_BOOKINGS_SUCCESS: 'booking.fetch_my_bookings_success',
      FETCH_MY_BOOKINGS_ERROR: 'booking.fetch_my_bookings_error',

      // Detail
      FETCH_BOOKING_DETAIL: 'booking.fetch_booking_detail',
      FETCH_BOOKING_DETAIL_SUCCESS: 'booking.fetch_booking_detail_success',

      // Actions
      CANCEL_BOOKING: 'booking.cancel_booking',
      CANCEL_BOOKING_SUCCESS: 'booking.cancel_booking_success',

      DOWNLOAD_TICKET: 'booking.download_ticket',
      SHARE_TICKET: 'booking.share_ticket',

      // Check-in
      CHECK_IN: 'booking.check_in',
      CHECK_IN_SUCCESS: 'booking.check_in_success',
    }
  },
  ENDPOINTS: {
    BOOKING: {
      MY_BOOKINGS: '/bookings/my',
      BOOKING_DETAIL: '/bookings/{id}',
      CANCEL: '/bookings/{id}/cancel',
      DOWNLOAD: '/bookings/{id}/download',
      QR_CODE: '/bookings/{id}/qr',
      CHECK_IN: '/bookings/{id}/check-in',
    }
  },
  BOOKING_STATUS: {
    CONFIRMED: 'confirmed',
    CANCELLED: 'cancelled',
    USED: 'used',
    REFUNDED: 'refunded',
  }
};
